export const importResult = {
  FULLIMPORT: 1,
  PARTLYIMPORT: 2,
  NOTIMPORT: 3,
};
